export const docusignActionData = [
  {
    name: 'initiateDocusign',
    label: 'Initiate Docusign',
    args: [
      {
        name: 'successRedirectUrl',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'sendForEsign',
    label: 'Send for eSign',
    args: [
      {
        name: 'agreementTemplate',
        label: 'Agreement Template',
        type: 'dropdown',
        optionsType: 'agreementTemplateApi',
        options: [],
        value: '',
      },
    ],
  },
];
